import { styled } from '@styledComponents';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeMediaQuery } from '@utils/styledTheme.util';

export interface ImageStylesProps {
  width: number;
  height: number;
  top?: number;
  left?: number;
  right?: number;
  borderRadius?: string;
  zIndex?: number;
  show?: boolean;
  rotate?: number;
  showBoxShadow?: boolean;
}

export const StyledCloudImage = styled(PlaceholderCloudImage)<{ mobile: ImageStylesProps; sm: ImageStylesProps }>`
  position: absolute;
  ${props => {
    return {
      width: `${props.mobile.width}px`,
      height: 'auto',
      minHeight: `${props.mobile.height}px`,
      top: props.mobile.top ?? '',
      left: props.mobile.left ?? '',
      right: props.mobile.right ?? '',
      zIndex: props.mobile.zIndex ?? '',
      borderRadius: props.mobile.borderRadius ?? '4px',
      visibility: props.mobile.show ? 'visible' : 'hidden',
      transform: `rotate(${props.mobile.rotate ?? 0}deg)`,
      boxShadow: props.mobile.showBoxShadow ? '0px 7px 27px rgba(44, 41, 37, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.07)' : 'none',
    };
  }}
  ${themeMediaQuery('sm')} {
    ${props => {
      return {
        width: `${props.sm.width}px`,
        height: 'auto',
        minHeight: `${props.sm.height}px`,
        top: props.sm.top ?? '',
        left: props.sm.left ?? '',
        right: props.sm.right ?? '',
        zIndex: props.sm.zIndex ?? '',
        borderRadius: props.sm.borderRadius ?? '4px',
        visibility: (props.sm.show ?? true) === false ? 'hidden' : 'visible',
        transform: `rotate(${props.sm.rotate ?? 0}deg)`,
        boxShadow:
          (props.sm.showBoxShadow ?? true) === false ? 'none' : '0px 7px 27px rgba(44, 41, 37, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.07)',
      };
    }}
  }
`;
